import { omniAtom } from "src/utils/atoms";

import { Toast } from "../types/types";

export const atomToasts = omniAtom({
	key: "toasts",
	value: [] as Toast[],
});
